import { Alerts } from "../../../../utils/Alerts.js";
import { useRPCContext } from "../../../../contexts/RPCContext.js";
import { FormikFilesPicker } from "../../../Files/shared/FormikFilesPicker.js";
import { FilesListDisplay } from "../../../Files/shared/FilesListDisplay.js";
import { FormikRichTextEditor } from "../../../../components/FormikFields/FormikRichTextEditor.js";
import { FormikText } from "../../../../components/FormikFields/FormikText.js";
import { handleUploadFile } from "../../../Files/shared/handle-upload-file.js";
import { FormikSelectUserAndGroupForCommunications } from "../../../Users/shared/FormikSelectUserAndGroupForCommunications.js";
import { useState } from "react";
import { Button, FormLayout, Icon, Modal } from "@therms/atalaya";
import { IoSend } from "react-icons/io5";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdOutlineAttachment } from "react-icons/md";
import { Formik } from "formik";
import * as Yup from "yup";
// src/modules/Mail/components/MailMessageForm/index.tsx
var ValidationSchema = Yup.object().shape({
	body: Yup.string(),
	bodyHtml: Yup.string().nullable(),
	ccUserAndGroupIds: Yup.array().nullable(),
	fileUrls: Yup.array().nullable(),
	receiverUserAndGroupIds: Yup.array().min(1, "You must select at least one recipient").required(),
	subject: Yup.string(),
	threadId: Yup.string().nullable(),
	urgent: Yup.boolean().nullable()
});
var initialValuesDefault = {
	body: "",
	bodyHtml: "",
	ccUserAndGroupIds: [],
	fileUrls: [],
	receiverUserAndGroupIds: [],
	subject: "",
	threadId: "",
	urgent: false
};
var MailAction = /* @__PURE__ */ function(MailAction) {
	MailAction["Forward"] = "forward";
	MailAction["New"] = "new";
	MailAction["Reply"] = "reply";
	MailAction["ReplyAll"] = "reply_all";
	return MailAction;
}({});
var MailMessageForm = ({ initialValues, onComplete }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { rpcService } = useRPCContext();
	const send = async (values) => {
		try {
			await rpcService.Mail.SendMessage.v1.call({ mailMessage: {
				body: values.body,
				bodyHtml: values.bodyHtml,
				ccUserAndGroupIds: values.ccUserAndGroupIds,
				fileUrls: values.fileUrls,
				receiverUserAndGroupIds: values.receiverUserAndGroupIds,
				subject: values.subject || "",
				threadId: values.threadId,
				urgent: values.urgent
			} });
			Alerts.success("Message sent successfully");
			onComplete();
		} catch (err) {
			console.log("Mail.SendMessage.v1.call err", err);
			Alerts.error("There was a problem sending the message", err.message);
		}
	};
	return /* @__PURE__ */ jsx(Formik, {
		enableReinitialize: true,
		initialValues: {
			...initialValuesDefault,
			...initialValues
		},
		onSubmit: async (values, actions) => {
			await send(values);
			actions.resetForm();
			onComplete();
		},
		validationSchema: ValidationSchema,
		children: ({ isSubmitting, isValid, submitForm, values }) => {
			return /* @__PURE__ */ jsxs(FormLayout, {
				dividers: "space",
				space: "xxs",
				heading: "New Message",
				children: [
					/* @__PURE__ */ jsx(FormikSelectUserAndGroupForCommunications, {
						isClearable: true,
						multi: true,
						name: "receiverUserAndGroupIds",
						placeholder: "To"
					}),
					/* @__PURE__ */ jsx(FormikSelectUserAndGroupForCommunications, {
						isClearable: true,
						multi: true,
						name: "ccUserAndGroupIds",
						placeholder: "CC"
					}),
					/* @__PURE__ */ jsx(FormikText, {
						name: "subject",
						placeholder: "Subject"
					}),
					/* @__PURE__ */ jsx(FormikRichTextEditor, {
						initialHTML: values?.bodyHtml,
						name: "body",
						htmlName: "bodyHtml",
						onImageUpload: async (file) => {
							return await handleUploadFile(file);
						}
					}),
					!!values.fileUrls.length && /* @__PURE__ */ jsx(FilesListDisplay, { fileUrls: values.fileUrls || [] }),
					/* @__PURE__ */ jsxs(Button, {
						subtle: true,
						onClick: () => setIsModalOpen(true),
						children: ["Attach Files", /* @__PURE__ */ jsx(Icon, {
							className: "ml-xs",
							Icon: MdOutlineAttachment,
							rotate: "3/4"
						})]
					}),
					/* @__PURE__ */ jsxs(Button, {
						disabled: !isValid,
						fullWidth: true,
						loading: isSubmitting,
						onClick: submitForm,
						variant: "main",
						children: ["Send Message", /* @__PURE__ */ jsx(Icon, {
							className: "ml-base",
							Icon: IoSend
						})]
					}),
					isModalOpen && /* @__PURE__ */ jsx(Modal, {
						closeHandler: () => setIsModalOpen(false),
						header: "Attachments",
						children: /* @__PURE__ */ jsx("div", {
							className: "bg-surface-subtle p-xxl text-color-subtle rounded text-center italic",
							children: /* @__PURE__ */ jsx(FormikFilesPicker, {
								multi: true,
								name: "fileUrls"
							})
						})
					})
				]
			});
		}
	});
};
export { MailAction, MailMessageForm };

//# sourceMappingURL=index.js.map